/* ============================================================
   F2G — Article Ranking
   Client-side logic for blog posts with product ranking sidebar.
   Cards are rendered server-side via Liquid, so this JS only handles:
   - ATC (add to cart) with GA4 + Web Pixels tracking
   - FAQ accordion
   - Mobile carrusel hint visibility
   ============================================================ */
(function(){
  'use strict';

  function $$(sel, ctx){ return Array.from((ctx||document).querySelectorAll(sel)); }
  function formatEUR(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; }

  // ─────────────────────────────────────────────
  // ATC: añadir al carrito con tracking GA4 + Web Pixels
  // ─────────────────────────────────────────────
  function setupATC(){
    $$('.f2g-sidebar-pc-atc[data-variant-id]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if (btn.disabled || btn.classList.contains('added')) return;
        var variantId = btn.getAttribute('data-variant-id');
        var productHandle = btn.getAttribute('data-product-handle') || '';
        var productTitle = btn.getAttribute('data-product-title') || '';
        var productPrice = parseFloat(btn.getAttribute('data-product-price') || '0');
        var productVendor = btn.getAttribute('data-product-vendor') || '';

        if (!variantId) return;
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(r){ return r.json(); })
        .then(function(item){
          btn.classList.add('added');
          btn.setAttribute('aria-label', 'Añadido');
          // GA4 dataLayer push
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'EUR',
              value: productPrice,
              items: [{
                item_id: variantId,
                item_name: productTitle,
                item_brand: productVendor,
                price: productPrice,
                quantity: 1,
                item_list_name: 'Article ranking sidebar'
              }]
            }
          });
          // Web Pixels publish (Klaviyo, Meta, etc.)
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('product_added_to_cart', {
              cartLine: item
            });
          }
          // Notificar al theme para que actualice el cart drawer si existe
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          // Re-habilitar tras 1.5s
          setTimeout(function(){ btn.disabled = false; }, 1500);
        })
        .catch(function(err){
          console.warn('[F2G ATC] error:', err);
          btn.disabled = false;
        });
      });
    });
  }

  // ─────────────────────────────────────────────
  // FAQ accordion (toggle preguntas)
  // v4.1 (Jaraiz_Sessions 19/05/2026): ampliado para soportar AMBOS selectores
  //   - .f2g-faq-q       → theme legacy (parent .open)
  //   - .f2g-faq-question → body v3.2 (parent .f2g-faq-item.active)
  // Esto permite eliminar el <script> inline del body_html en v4.1
  // sin romper artículos ya publicados con uno u otro patrón.
  // ─────────────────────────────────────────────
  function setupFAQ(){
    // Patrón legacy: .f2g-faq-q → .open en el padre
    $$('.f2g-faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        var item = q.parentElement;
        if (!item) return;
        item.classList.toggle('open');
        q.setAttribute('aria-expanded', item.classList.contains('open'));
      });
    });

    // Patrón v3.2: .f2g-faq-question → .active en el ancestro .f2g-faq-item
    $$('.f2g-faq-question').forEach(function(q){
      // Evitar doble binding si el body antiguo trae su propio <script>
      if (q.dataset.f2gFaqBound === '1') return;
      q.dataset.f2gFaqBound = '1';
      q.addEventListener('click', function(){
        var item = q.closest('.f2g-faq-item');
        if (!item) return;
        item.classList.toggle('active');
        q.setAttribute('aria-expanded', item.classList.contains('active'));
      });
    });
  }

  // ─────────────────────────────────────────────
  // Mobile carrusel: ocultar hint tras primer swipe
  // ─────────────────────────────────────────────
  function setupCarrusel(){
    var carrusel = document.querySelector('.f2g-sidebar-cards');
    if (!carrusel) return;
    var hint = document.querySelector('.f2g-sidebar-hint');
    if (!hint) return;
    var hidden = false;
    carrusel.addEventListener('scroll', function(){
      if (hidden) return;
      if (carrusel.scrollLeft > 20){
        hint.style.opacity = '0';
        hint.style.transition = 'opacity 0.3s ease';
        setTimeout(function(){ hint.style.display = 'none'; }, 300);
        hidden = true;
      }
    }, { passive: true });
  }

  // ─────────────────────────────────────────────
  // Bootstrap
  // ─────────────────────────────────────────────
  function init(){
    setupATC();
    setupFAQ();
    setupCarrusel();
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
